import type { ComponentProps } from 'react';
import { createRoot } from 'react-dom/client';
import { initializeCrowdinIframeContext } from '../lib/crowdin-iframe-context';
import { readPageProps } from '../lib/page-props';
import { ErrorPage } from '../pages/ErrorPage';

initializeCrowdinIframeContext();

const props = readPageProps<ComponentProps<typeof ErrorPage>>();

createRoot(document.getElementById('root')!).render(<ErrorPage {...props} />);
